import React, { ReactNode } from 'react';
import { Icon, Button } from '@web-components-proxy';

export const headingHandler = (className: string, title: string): ReactNode => {
	return (
		<h6 key="title" className={`data-row__heading ${className}`}>
			{title}
		</h6>
	);
};

export const editBtnHandler = (action: () => void): ReactNode => {
	if (!action) return;
	return (
		<Button size="small" design="primary" class="data-row__icon__edit hydrated" isRounded={true} onClick={action}>
			<Icon iconName="pen"></Icon>
		</Button>
	);
};

export enum HeadingClass {
	FALSE = 'data-row__heading__false',
	TRUE = 'data-row__heading__true',
	CONTENT = 'data-row__heading__content',
}

export enum IconClass {
	FALSE = 'data-row__icon__false hydrated',
	TRUE = 'data-row__icon__true hydrated',
}

export enum DataRowSeverity {
	DEFAULT = '',
	DANGER = 'danger',
}

export interface DataCradRowContentProps {
	title: string;
	value: string | ReactNode;
	totalValue?: boolean | number | string | null;
	customValue?: boolean | number | string | null;
	isEditable: boolean;
	editPermission: boolean;
	suffix?: string;
	logAmount? : boolean | number | string | null;
	openModal?: () => void;
	additionalClassName?: string | null;
	omitLimitNumbersFormatting?: boolean | null;
	severity?: DataRowSeverity;
}
